import IFormWithBiometricsFilter  from "../../models/misconfig/FormWithBiometricsFilter";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { usePermissionCheck } from "../../app/common/helper/Permissions";
import { Permissions } from "../../app/enums";

export default function BiometricFilterEdit(props: IFormWithBiometricsFilter) {        
    const canEditEstablishments = usePermissionCheck(Permissions.CanEditEstablishments);

    const updateBiometricValue = (index: number, type: string, value: string) => {
        if(type === 'FR') {
            const updatedFR = [...props.biometricsFilter?.FaceRecognition || []];
            updatedFR[index] = value;
            props.setBiometricsFilter({
                FaceRecognition: updatedFR,
                Fingerprints: props.biometricsFilter?.Fingerprints || []
            });
            return;
        } else if(type === 'FP') {
            const updatedFP = [...props.biometricsFilter?.Fingerprints || []];
            updatedFP[index] = value;   
            props.setBiometricsFilter({
                FaceRecognition: props.biometricsFilter?.FaceRecognition || [],
                Fingerprints: updatedFP
            });
            return;
        }
    }

    const removeBiometric = (index: number, type: string) => {
        if(type === 'FR') {
            const updatedFR = props.biometricsFilter?.FaceRecognition.filter((_, idx) => idx !== index) || [];
            props.setBiometricsFilter({
                FaceRecognition: updatedFR,
                Fingerprints: props.biometricsFilter?.Fingerprints || []
            });
            return;
        } else if(type === 'FP') {
            const updatedFP = props.biometricsFilter?.Fingerprints.filter((_, idx) => idx !== index) || [];
            props.setBiometricsFilter({
                FaceRecognition: props.biometricsFilter?.FaceRecognition || [],
                Fingerprints: updatedFP
            });
            return;
        }        
    }

    const appendBiometric = (type: string) => {
        if(type === 'FR') {
            const updatedFR = [...props.biometricsFilter?.FaceRecognition || [], ''];
            props.setBiometricsFilter({
                FaceRecognition: updatedFR,
                Fingerprints: props.biometricsFilter?.Fingerprints || []
            });
            return;
        } else if(type === 'FP') {
            const updatedFP = [...props.biometricsFilter?.Fingerprints || [], ''];
            props.setBiometricsFilter({
                FaceRecognition: props.biometricsFilter?.FaceRecognition || [],
                Fingerprints: updatedFP
            });
            return;
        }        
    }

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={2} className="pt-2"><i><b>Biometric filters</b></i></Col>
            </Row>                
            {props.biometricsFilter?.FaceRecognition.map((value, idx) => (
            <Row className="pb-2" key={`faceRec-${idx}`}>  
                <Col md={2} className="ps-4"><b>{idx === 0 ? 'Facial recognition' : ''}</b></Col>
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Facial recognition"
                        value={value}
                        onChange={(e) => updateBiometricValue(idx, 'FR', e.target.value)} />
                </Col>
                <Col>
                {canEditEstablishments &&
                    <button className="btn btn-light red-color" onClick={() => removeBiometric(idx, 'FR')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>}
                </Col>                    
            </Row>
            ))}
             {canEditEstablishments && 
             <Row className="pb-2">
                <Col md={2} className="ps-4"><b>{props.biometricsFilter?.FaceRecognition.length === 0 ? 'Facial recognition' : ''}</b></Col>
                <Col md={4}>
                    <button
                        type="button"
                        className="btn"
                        onClick={() => appendBiometric('FR')}
                        style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Facial Recognition filter">
                        + Add New
                    </button>
                </Col>
            </Row>}
            {props.biometricsFilter?.Fingerprints.map((value, idx) => (
            <Row className="pb-2" key={`fingerprints-${idx}`}>  
                <Col md={2} className="ps-4"><b>{idx === 0 ? 'Fingerprints' : ''}</b></Col>
                <Col md={4}>
                    <input
                        type="text"
                        className="form-control ms-2"
                        placeholder="Enter value for Fingerprints"
                        value={value}
                        onChange={(e) => updateBiometricValue(idx, 'FP', e.target.value)} />
                </Col>
                <Col>
                {canEditEstablishments &&
                    <button className="btn btn-light red-color" onClick={() => removeBiometric(idx, 'FP')}>
                        <FontAwesomeIcon icon={faTrashCan} />
                    </button>}
                </Col>                    
            </Row>
            ))}
             {canEditEstablishments && 
             <Row className="pb-2">
                <Col md={2} className="ps-4"><b>{props.biometricsFilter?.Fingerprints.length === 0 ? 'Fingerprints' : ''}</b></Col>
                <Col md={4}>
                    <button
                        type="button"
                        className="btn"
                        onClick={() => appendBiometric('FP')}
                        style={{ fontSize: '1.0rem', lineHeight: '1', color: '#007bff' }}
                        aria-label="Add Fingerprints filter">
                        + Add New
                    </button>
                </Col>
            </Row>}            
        </React.Fragment>
    );
}
